import { OctagonAlert } from 'lucide-react';
import React from 'react';

export const EmptyState = ({ title, description, margin }) => (
  <div className={`flex flex-col items-center justify-center ${margin}`}>
    <OctagonAlert className="text-inactive-text" size={24} />
    <p className="text-inactive-text font-bold text-lg m-0 mt-4 mb-1">
      {title}
    </p>
    <p className=" text-inactive-text text-base m-0">{description}</p>
  </div>
);
